import { render } from "./TelegramList.vue?vue&type=template&id=819b3ede&lang=pug"
import script from "./TelegramList.vue?vue&type=script&lang=js"
export * from "./TelegramList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__